export {default as assert} from './assert';
export {default as isOldIE} from './is-old-ie';
export {uid, isPowerOfTwo, isObjectEmpty} from './utils';
export {formatValue} from './format-value';
export {stubRemovedMethods} from './stub-methods';
export {checkProps} from './check-props';
